import { render, staticRenderFns } from "./addPush.vue?vue&type=template&id=1f318fa4"
import script from "./addPush.vue?vue&type=script&lang=js"
export * from "./addPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports